import React, { useId} from "react";
import "./socialComite.css";

// Links por defecto (edítalos aquí una sola vez)
const DEFAULT_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61586978380646",
  instagram: "https://www.instagram.com/comitejuventudfacach/",
  youtube: "https://www.youtube.com/@facachfacach",
  x: "https://x.com/Facachhn",
  linkedin: "https://www.linkedin.com/company/facach/posts/?feedView=all",
  tiktok: "https://www.tiktok.com/@comitejuventud_facach?_r=1&_t=ZS-96Ko20eCPzz",
};

const SocialComite = ({
  links,               // opcional: sobreescribe alguno(s)
  size = 42,           // tamaño de cada botón (px)
  rounded = true,      // bordes del bloque contenedor
  ariaLabel = "Redes sociales (Comité)",
  className = "",      // estilos extra desde fuera

  
title = "Únete a la energía del cooperativismo juvenil ",
  subtitle = "Síguenos en nuestras redes sociales",
  titleTag: TitleTag = "h2",
  subtitleTag: SubtitleTag = "p",
  showDivider = false, // opcional: línea decorativa entre título y botones

}) => {
  const merged = { ...DEFAULT_LINKS, ...(links || {}) };
  const headingId = useId();
  return (
    
<section
      className={`social-comite-block ${className}`}
      aria-labelledby={title ? headingId : undefined}
    >
      {(title || subtitle) && (
        <header className="social-comite__header">
          {title && (
            <TitleTag id={headingId} className="social-comite__title">
              {title}
            </TitleTag>
          )}
          {subtitle && (
            <SubtitleTag className="social-comite__subtitle">
              {subtitle}
            </SubtitleTag>

)}
          {showDivider && <span className="social-comite__divider" aria-hidden="true" />}
        </header>
      )}


    <nav
      className={`social-comite ${rounded ? "social-comite--rounded" : ""} ${className}`}
      aria-label={ariaLabel}
    >
      {/* Facebook */}
      <a
        href={merged.facebook}
        className="social-comite__btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        title="Facebook"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.35C0 23.407.593 24 1.325 24h11.49v-9.294H9.847V11.01h2.968V8.41c0-2.94 1.794-4.542 4.416-4.542 1.254 0 2.33.093 2.644.135v3.064h-1.816c-1.426 0-1.702.678-1.702 1.67v2.273h3.404l-.444 3.696h-2.96V24h5.805C23.407 24 24 23.407 24 22.675V1.325C24 .593 23.407 0 22.675 0z"/>
        </svg>
      </a>


      {/* Instagram */}
      <a
        href={merged.instagram}
        className="social-comite__btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        title="Instagram"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403.61.224 1.047.492 1.507.952.46.46.728.897.952 1.507.163.457.347 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427a3.93 3.93 0 0 1-.952 1.507 3.93 3.93 0 0 1-1.507.952c-.457.163-1.257.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a3.93 3.93 0 0 1-1.507-.952 3.93 3.93 0 0 1-.952-1.507c-.163-.457-.347-1.257-.403-2.427C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427.224-.61.492-1.047.952-1.507.46-.46.897-.728 1.507-.952.457-.163 1.257-.347 2.427-.403C8.416 2.175 8.796 2.163 12 2.163zm0 1.622c-3.162 0-3.532.012-4.777.069-.98.045-1.51.208-1.862.345-.469.182-.803.4-1.155.752-.352.352-.57.686-.752 1.155-.137.352-.3.882-.345 1.862-.057 1.245-.069 1.615-.069 4.777s.012 3.532.069 4.777c.045.98.208 1.51.345 1.862.182.469.4.803.752 1.155.352.352.686.57 1.155.752.352.137.882.3 1.862.345 1.245.057 1.615.069 4.777.069s3.532-.012 4.777-.069c.98-.045 1.51-.208 1.862-.345.469-.182.803-.4 1.155-.752.352-.352.57-.686.752-1.155.137-.352.3-.882.345-1.862.057-1.245.069-1.615.069-4.777s-.012-3.532-.069-4.777c-.045-.98-.208-1.51-.345-1.862-.182-.469-.4-.803-.752-1.155a2.76 2.76 0 0 0-1.155-.752c-.352-.137-.882-.3-1.862-.345-1.245-.057-1.615-.069-4.777-.069zm0 3.351A4.864 4.864 0 1 1 7.136 12 4.864 4.864 0 0 1 12 7.136zm0 8.106A3.242 3.242 0 1 0 8.758 12 3.242 3.242 0 0 0 12 15.242zM17.339 6.62a1.134 1.134 0 1 1-1.134-1.134 1.134 1.134 0 0 1 1.134 1.134z"/>
        </svg>
      </a>


      {/* TikTok */}
      <a
        href={merged.tiktok}
        className="social-comite__btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        title="TikTok"
        style={{ width: size, height: size }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21 8.17a6.9 6.9 0 0 1-4.37-1.53v7.11a6.55 6.55 0 1 1-6.55-6.56c.26 0 .52.02.77.06v3.51a3.07 3.07 0 1 0 2.17 2.94V2.5h3.46a6.9 6.9 0 0 0 4.52 4.2V8.17z"/>
        </svg>
      </a>
    </nav>
    </section>
  );
};

export default SocialComite;
